import React from 'react';
import Header from '../components/Header';
import Ticker from '../components/Ticker';
import QuickStats from '../components/QuickStats';
import PriceChart from '../components/PriceChart';
import PriceTable from '../components/PriceTable';
import Footer from '../components/Footer';
import { useCurrency } from '../context/CurrencyContext';
import { useTheme } from '../context/ThemeContext';
import { Coins, Loader2 } from 'lucide-react';

const HomePage = () => {
  const { prices, isLoading } = useCurrency();
  const { theme } = useTheme();

  if (isLoading) {
    return (
      <div 
        className="min-h-screen flex items-center justify-center transition-colors duration-300"
        style={{ backgroundColor: theme.bg }}
      >
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-[#d4af37] animate-spin mx-auto mb-4" />
          <p style={{ color: theme.textSecondary }}>Loading market data...</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen transition-colors duration-300"
      style={{ backgroundColor: theme.bg }}
    >
      <Header />
      <Ticker />
      
      <main className="max-w-7xl mx-auto px-4 py-6">
        {/* Quick Stats */}
        <QuickStats />

        {/* Price Chart */}
        <PriceChart />

        {/* Main Price Table */}
        <div className="mb-6">
          <PriceTable 
            title="Precious Metals Prices" 
            data={prices} 
            icon={Coins}
            color="#d4af37"
          />
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div 
            className="rounded-xl border p-6 transition-colors duration-300"
            style={{ backgroundColor: theme.bgCard, borderColor: theme.border }}
          >
            <h3 className="text-[#d4af37] font-semibold mb-2">Real-Time Data</h3>
            <p className="text-sm" style={{ color: theme.textSecondary }}>Prices are updated every few seconds with live market data from trusted sources.</p>
          </div>
          <div 
            className="rounded-xl border p-6 transition-colors duration-300"
            style={{ backgroundColor: theme.bgCard, borderColor: theme.border }}
          >
            <h3 className="text-[#d4af37] font-semibold mb-2">Multi-Currency</h3>
            <p className="text-sm" style={{ color: theme.textSecondary }}>View prices in USD, EUR, TRY, or AED. Click Settings to change your preferred currency.</p>
          </div>
          <div 
            className="rounded-xl border p-6 transition-colors duration-300"
            style={{ backgroundColor: theme.bgCard, borderColor: theme.border }}
          >
            <h3 className="text-[#d4af37] font-semibold mb-2">Free APIs</h3>
            <p className="text-sm" style={{ color: theme.textSecondary }}>Data powered by FreeGoldAPI and Frankfurter API - free, open, and reliable.</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
